/**
 * tourSteps/projectsListSteps.js
 * Tour steps for the Project Dashboard directory & KPI metrics overview.
 */

export const projectsListSteps = [
    {
        title: 'Project KPI Metrics',
        description: 'Track high-level health metrics including total active projects, completed deliverables, on-hold initiatives, and overdue schedules at a single glance.',
        selector: '[data-tour="project-kpi-cards"]',
        placement: 'bottom',
    },
    {
        title: 'Search & Multi-Dimensional Filters',
        description: 'Easily isolate projects by owner, department, category, execution status, or instant keyword search.',
        selector: '[data-tour="project-filters"]',
        placement: 'bottom',
    },
    {
        title: 'Pending CRE Client Requests',
        description: 'Review incoming client project requests submitted via the CRE portal. The review carousel lets managers inspect scope and convert them directly into active ERP projects.',
        selector: '[data-tour="pending-cre-requests-btn"]',
        fallbackSelector: '[data-tour="new-project-btn"]',
        placement: 'bottomLeft',
    },
    {
        title: 'New Project Creation Wizard',
        description: 'Launch the comprehensive 5-step project creation wizard to define project basics, assign teams and role permissions, establish milestones, and configure views.',
        selector: '[data-tour="new-project-btn"]',
        placement: 'bottomLeft',
    },
    {
        title: 'Central Projects Table & 360° Inspector',
        description: 'View active project budgets, team allocations, timelines, and status chips. Click any project row to open the complete Project 360° Details Modal with milestone progress and asset files.',
        selector: '[data-tour="project-list-table"]',
        placement: 'top',
    },
];
